module.exports = __webpack_public_path__ + "img/yes.841b23.gif";